import { useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { getRedirectToIfNeeded } from '@zg-rentals/shields-js';
import { TERMS, ZTSS_LANDING } from '../../../constants/paths';

export default function useRedirectUrl() {
  const location = useLocation();
  const termsMatch = useRouteMatch(TERMS);
  const ztssLandingMatch = useRouteMatch(ZTSS_LANDING);
  const isInWebView = useSelector((state) => state.app.isInWebView);
  const loggedIn = useSelector((state) => state.user.loggedIn);
  const hasStrongAuthentication = useSelector((state) => state.user.hasStrongAuthentication);
  const impersonatorUserToken = useSelector((state) => state.user.impersonatorUserToken);
  const impersonatorEmail = useSelector((state) => state.user.impersonatorEmail);
  const routing = { location }; // shields-js expects an object with location and calls it "routing"

  if (termsMatch || ztssLandingMatch) {
    return null;
  }
  return getRedirectToIfNeeded({
    brand: 'zillow',
    routing,
    loggedIn,
    requireStrongAuthentication: true,
    hasStrongAuthentication,
    // this feature of shields-js is intentionally not used after switching to Zillow 2FA
    // see RA-390 for more details
    isTwoFactorAuthEnabled: null,
    isTwoFactorAuthenticated: null,
    impersonatorEmail,
    impersonatorUserToken,
    isInWebView,
  });
}
